<template>
  <div class="h-100">
    <div class="content-page p-3 pb-5 h-100">
      <b-row>
        <b-col
          cols="12"
          class="text-right"
          v-if="hasRight(Settings.Permission.Change) && hasRight('AlwWrite')"
        >
          <button
            class="btn btn-info"
            @click="initRosterPlan"
            v-b-modal.modal-RosterPlan
          >
            {{ `${this.t.t(dictEnum.LBL_Add)} ` }}
          </button>
          <!-- <button class="btn btn-danger" @click="saveRosterPlan">
            {{ `${this.t.t(dictEnum.BTN_Save)} ` }}
          </button> -->
        </b-col>
      </b-row>
      <b-row class="h-100">
        <b-col cols="12" class="h-100 pb-5">
          <div class="tab-content bg-white h-100">
            <div class="tab-pane active table-responsive color-table">
              <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
              >
                <template slot="Action" slot-scope="props">
                  <div>
                    <font-awesome-icon
                      icon="edit"
                      style="cursor:pointer"
                      v-b-modal.modal-RosterPlan
                      @click="editRosterPlan(props.row)"
                    />
                    <!-- v-if="hasRight(Settings.Permission.Change)" -->

                    <font-awesome-icon
                      icon="trash"
                      style="cursor:pointer"
                      @click="deleteRosterPlan(props.row)"
                    />
                    <!-- v-if="hasRight('AlwDel')" -->
                  </div>
                </template>
              </v-client-table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal
      id="modal-RosterPlan"
      :title="mode == 'new' ? t.t(dictEnum.LBL_Add) : t.t(dictEnum.LBL_Edit)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="editOrAddRosterPlan"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{
                t.t(dictEnum.LBL_RosterPlanCode)
              }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-input
              v-model="RosterPlan.RosterPlanCode"
              maxlength="15"
              :readonly="mode === 'new' ? false : true"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Description) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-input
              v-model="RosterPlan.PlanDesc"
              maxlength="50"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row
          class="my-1 no-gutters"
          v-for="(weekday, index) in [
            { label: 'LBL_Mon', value: 'Shift1' },
            { label: 'LBL_Tue', value: 'Shift2' },
            { label: 'LBL_Wed', value: 'Shift3' },
            { label: 'LBL_Thu', value: 'Shift4' },
            { label: 'LBL_Fri', value: 'Shift5' },
            { label: 'LBL_Sat', value: 'Shift6' },
            { label: 'LBL_Sun', value: 'Shift7' }
          ]"
          :key="index"
        >
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum[weekday.label]) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-select
              v-model="RosterPlan[weekday.value]"
              :options="shiftTypeList"
              class="mt-2"
              value-field="ShiftCode"
              text-field="ShiftCode"
            >
            </b-form-select>
            <!-- :style="`background:${routerShareColor(RosterPlanCode[weekday.value])}`" -->
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_HolidayType) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-select
              name="shift"
              v-model="RosterPlan.HolidayType"
              size="sm"
              class="mt-2"
            >
              <option value="" selected> </option>
              <option
                v-for="(holiday, holidayIndex) in Settings.HolidayType"
                :key="holidayIndex"
                :value="holiday.value"
              >
                {{ holiday.label }}
              </option>
            </b-form-select>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MenuRightSerivce from "@/service/MenuRightService";
import RosterPlanService from "@/service/RosterPlanService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { RosterPlan } from "@/model/RosterPlan";
import ShiftTypeService from "@/service/ShiftTypeService";
import Settings from "../../constants/Settings";
import moment from "moment";

export default {
  components: {
    moment
  },
  computed: {
    t() {
      return t;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.MM_RosterPlan,
      // menuId: Settings.MenuID.MM_RosterPlanCode,
      Settings: Settings,
      columns: [
        "RosterPlanCode",
        "PlanDesc",
        "Shift1",
        "Shift2",
        "Shift3",
        "Shift4",
        "Shift5",
        "Shift6",
        "Shift7",
        "HolidayType",
        "Action"
      ],
      tableData: [],
      dictEnum: dictEnum,
      options: {
        filterable: false,
        perPageValues: [],
        sortable: [],
        skin: "table table-hover v-midle",
        headings: {
          RosterPlanCode: "Roster Plan Code",
          PlanDesc: "Description",
          Shift1: "Mon",
          Shift2: "Tue",
          Shift3: "Wed",
          Shift4: "Thu",
          Shift5: "Fri",
          Shift6: "Sat",
          Shift7: "Sun",
          HolidayType: "HolidayType",
          Action: "Action"
        },
        columnsClasses: {}
      },
      mode: "new",
      RosterPlan: new RosterPlan(),
      shiftTypeList: [],
      selectedUserID: [],
      lisRosterPlan: []
    };
  },
  methods: {
    hasRight(key) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    initRosterPlan() {
      this.mode = "new";
      this.RosterPlan = new RosterPlan();
    },
    async editRosterPlan(rosterPlan) {
      this.mode = "edit";
      this.RosterPlan = rosterPlan;
    },
    async deleteRosterPlan(grade) {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          rosterplan: grade
        };
        const response = await RosterPlanService.deleteRosterPlan(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.getDataTable();
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async editOrAddRosterPlan() {
      if (!this.RosterPlan.RosterPlanCode) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.MENU_RosterPlanCode) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      if (!this.RosterPlan.PlanDesc) {
        SweetAlertService.warning(
          "Warn",
          t.t(dictEnum.LBL_Description) + t.t(dictEnum.WARN_IsRequired)
        );
        return;
      }
      this.lisRosterPlan = [];
      this.lisRosterPlan.push(this.RosterPlan);
      let response = null;
      let obj = {};
      if (this.mode === "new") {
        obj = {
          rosterplan: this.RosterPlan
        };
        response = await RosterPlanService.addRosterPlan(obj);
      } else {
        obj = {
          lisRosterPlan: this.lisRosterPlan
        };
        response = await RosterPlanService.updateRosterPlan(obj);
      }
      if (response.data.IsSuccess) {
        this.RosterPlan = new RosterPlan();
        SweetAlertService.success("Success", response.Message);
        this.getDataTable();
      } else {
        this.RosterPlan = new RosterPlan();
        SweetAlertService.warning("Warn", response.Message);
      }
    },

    async getDataTable() {
      const response = await RosterPlanService.getRosterPlans();

      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getShiftType() {
      const obj = {};

      const response = await ShiftTypeService.getShiftType(obj);

      if (response.data.IsSuccess) {
        this.shiftTypeList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    routerShareColor(result) {
      let color = "white";
      const find = this.shiftTypeList.find(x => {
        return x.ShiftCode == result;
      });
      if (find) {
        color = find.Color;
      }
      return color;
    }
  },

  mounted() {
    this.assignRights();
    this.getDataTable();
    this.getShiftType();

    this.options = {
      filterable: false,
      perPageValues: [],
      /* texts: {
        limit: "Records : ",
        },*/
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        RosterPlanCode: t.t(dictEnum.LBL_RosterPlanCode),
        PlanDesc: t.t(dictEnum.LBL_Description),
        Shift1: t.t(dictEnum.LBL_Mon),
        Shift2: t.t(dictEnum.LBL_Tue),
        Shift3: t.t(dictEnum.LBL_Wed),
        Shift4: t.t(dictEnum.LBL_Thu),
        Shift5: t.t(dictEnum.LBL_Fri),
        Shift6: t.t(dictEnum.LBL_Sat),
        Shift7: t.t(dictEnum.LBL_Sun),
        HolidayType: t.t(dictEnum.LBL_HolidayType),
        Action: t.t(dictEnum.BTN_Update)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: ``
      },
      columnsClasses: {}
    };
  }
};
</script>
<style scoped>
.input-group-text {
  background: white;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/S050000-MM/S050900-RosterPlan.vue